import System from "src/helper/system";
import Common from "src/pages/HomePageContent/Common";
import CommonContent from "src/pages/HomePageContent/CommonContent";
import Helper from "src/support/Helper";
import Product from "./product";

let c = System.getParams();

class HomePages {
    static BROWSE_TABS_CONTENT_COUNT = Helper.getBrowseTabsUrl() + '/search/resources/store/10151/search/count'
    static BROWSE_TABS_CONTENT = Helper.getBrowseTabsUrl() + '/search/resources/store/10151/sitecontent/webContentsBySearchTerm/select'
    static CONTENT_TAB_COUNT = Helper.getBrowseTabsUrl() + '/search/resources/store/10151/search/contentcount'
    static DOCUMENT_CONTENT_DATA_LIST = Helper.getApplicationUrl() + '/api/application/product/documentsearch'
    static BROWSE_TABS_CONTENT_NEW = Helper.getBrowseTabsUrl() + '/wcs/resources/avnet/fspsitecontent/webContentsBySearchTerm'
    static CONTENT_TAB_COUNT_NEW = Helper.getBrowseTabsUrl() + '/search/resources/store/10151/search/fspcontentcount'

    static browse_tabs_param(value) {
        let c = {
            "storeId": 10151,
            "catalogId": 10001,
            "langId": -1,
            "orgEntityId": -2000,
            "contractId": 10006,
            "wt": "json",
            "profileName": "Avn_findWebContentBySearchTerm",
            "profileVideo": "Avn_findVideosBySearchTerm"
        }
        if (c[value] !== undefined) {
            return c[value];
        }
        return value;
    }

    static getHomeTabsListRouteURL(extra_c = {}) {
        // 16933 - Need to remove trailing slash condition - PN - 16/2/2024
        c[Common.param_key] = Common.chain.HomePageContent.param_value.replace(/\/$/, "");
        return this.getURLBasedOnParamKey({
            //...c,
            ...extra_c
        });
    }

    static makeHomeTabsListRouteURL(param_value) {
        return this.getHomeTabsListRouteURL({
            //...c,
            [Common.param_key_HomeTabList]: param_value
        });
    }

    static getHomeContentTabsListRouteURL(extra_c = {}) {
        c[CommonContent.param_key] = CommonContent.chain.HomePageContentTab.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getURLBasedOnParamKey(c) {
        return Product.getProductListingPageRouteURL(c);
    }
}

export default HomePages;